module.exports = __webpack_public_path__ + "static/media/pt-serif-v18-cyrillic_cyrillic-ext_latin_latin-ext-regular.418fe936.woff2";